(function () {
  const selector = '.single-line-carousel';

  function initSingleLineCarousel(sliderEl) {
    if (!sliderEl || sliderEl.dataset.initialized === 'true') return;

    const loop = sliderEl.dataset.loop === 'true';
    const autoplayEnabled = sliderEl.dataset.autoplay === 'true';
    const autoplayDelay = Number(sliderEl.dataset.autoplaySpeed || 4000);
    const spaceBetween = Number(sliderEl.dataset.spaceBetween || 12);

    const swiperEl = sliderEl.querySelector('.swiper');
    const nextEl = sliderEl.querySelector('.single-line-carousel__btn--next');
    const prevEl = sliderEl.querySelector('.single-line-carousel__btn--prev');
    const slideCount = sliderEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;

    if (!swiperEl || slideCount === 0) return;

    const enableLoop = loop && slideCount > 1;

    // eslint-disable-next-line no-undef
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween,
      speed: 550,
      loop: enableLoop,
      loopAdditionalSlides: Math.min(4, slideCount),
      watchOverflow: true,
      allowTouchMove: true,
      grabCursor: true,
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      navigation: nextEl && prevEl
        ? {
            nextEl,
            prevEl,
          }
        : undefined,
    });

    sliderEl.dataset.initialized = 'true';

    const updateNav = () => {
      if (!nextEl || !prevEl || enableLoop) return;
      const isFirst = swiper.realIndex === 0;
      const isLast = swiper.realIndex === slideCount - 1;
      nextEl.style.display = isLast ? 'none' : '';
      prevEl.style.display = isFirst ? 'none' : '';
    };

    updateNav();
    swiper.on('slideChange', updateNav);

    document.addEventListener('shopify:block:select', (event) => {
      const blockId = event?.detail?.blockId;
      if (!blockId || !swiper) return;
      const slideEl = sliderEl.querySelector(`[data-block-id="${blockId}"]`);
      if (!slideEl) return;
      const index = Array.from(slideEl.parentNode.children).indexOf(slideEl);
      swiper.slideToLoop(index);
    });
  }

  function init() {
    document.querySelectorAll(selector).forEach(initSingleLineCarousel);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

